<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="mrB10" />
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DOM_CLSF_NM')" :vertical="false" />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              maxlength="100"
              placeholder
              v-model="domainClass"
              name="wordName"
              @keyup.enter="searchWord"
            ></sui-text-field>
          </div>
          <div class="btn_wrap">
            <sui-button type="button" class="comm_btn_Reset" @click="onReset()" v-permission:read="'PGE_CMT_00001'">{{$t('MSG_BTN_RESET')}}</sui-button>
            <sui-button
              type="button"
              class="comm_btn_Scr"
              @click="searchWord()"
            v-permission:read="'PGE_CMT_00001'" >{{$t('MSG_BTN_SEARCH')}}</sui-button>
          </div>
        </div>
      </div>
      <div class="comm_title_wrap"></div>
      <div class="comm_gridTop_wrap"></div>
      <div class="inbox">
        <sui-tree-grid
          ref="treeGrid01"
          :columns="treeGridColumns01"
          :height="400"
          :dataset="'dataset0'"
          :selectionMode="'singleRow'"
          :initialPagesize="10"
           @rowClick="rowClick"
        />
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button type="button" class="comm_btn_border" @click="onCancel" v-permission:read="'PGE_CMT_00001'">{{$t('MSG_BTN_CANCEL')}}</sui-button>
      <sui-button type="button" class="comm_btn_solid" @click="onSelect" v-permission:read="'PGE_CMT_00001'">{{$t('MSG_BTN_SELT')}}</sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "PGE_CMZ_00001_P05", // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: "PGE_CMT_00001"
    },
    biddingInformationParam: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedDomClassId: "",
      selectedDomClassName: "",
      selectedWordId:"",
      domainClass: "",
      treeGridColumns01: [
        {
          text: this.$t('MSG_TXT_DOM_CLSF_ID'),
          datafield: "domainClassificationID"
        },
        {
          text: this.$t('MSG_TXT_DOM_CLSF_NM'),
          datafield: "domainClassificationName"
        }
      ],
      stateData: []
    };
  },
  mounted() {
    this.searchWord();
  },
  beforeDestroy() {},
  methods: {
    rowClick(event){
       this.selectedDomClassId = event.args.row.domainClassificationID;
       this.selectedDomClassName= event.args.row.domainClassificationName;
       this.selectedWordId = event.args.row.wordId;
    },
    onReset() {
      this.domainClass = "";
    },
    onSelect() {
      if (this.selectedDomClassId !== "") {
        const dataToEmit = {
          'domainClassificationName':this.selectedDomClassName,
          'domainClassId':this.selectedDomClassId,
          'wordId':this.selectedWordId,
        }
        this.$emit("wordPopulate", dataToEmit);
        this.onPopupCancelClicked();
      }
    },
    searchWord() {
      let queryParams;
      if (this.domainClass) {
        queryParams = { domainClassificationName: this.domainClass };
      }
      http
        .request("PGE_CMT_00001", "DTS_CMT_00046", { query: queryParams })
        .then(res => {

          console.log ( res.data );
          this.dataset0.setRawData(res.data);
        })
        .catch(error => {});
    },
    onClickSelectWord() {},
    onPopupCancelClicked() {
      this.$emit("exit", true);
    },
    onCancel() {
       this.$emit("exit", true);
    }
  },
  datasets: [
    // TreeGrid 데이타셋1
    {
      id: "dataset0",
      componentType: "tree-grid",
      data: "stateData",
      hierarchy: {
        keyDataField: {
          name: "id"
        },
        parentDataField: {
          name: "parentId"
        }
      },
      datafields: [
        {
          name: "domainClassificationID",
          type: "string",
          map: "domainClassificationID"
        },
        {
          name: "domainClassificationName",
          type: "string",
          map: "domainClassificationName"
        },
        {
          name: "selectedRow",
          type: "string",
          map: "selectedRow",
          rowSelect: ["Y", "N"]
        },
        {
          name: "id",
          type: "string",
          map: "domainClassificationID"
        },
        {
          name: "parentId",
          type: "string",
          map: "upperDomainClassificationID"
        },
        {
          name: "dataset-row-id",
          type: "string",
          map: "dataset-row-id"
        },
        {
          name: "upperDomainClassificationID",
          type: "string",
          map: "upperDomainClassificationID"
        },
        {
          name: "upperDomainClassificationName",
          type: "string",
          map: "upperDomainClassificationName"
        },
        {
          name: "wordId",
          type: "string",
          map: "wordId"
        }
      ]
    }
  ]
};
</script>

<style scoped>
</style>

